import React from "react";
import EditUser from "./EditUser";

export default function EditSpecialAccessUser(props){
   return <EditUser {...props} hideAdmin={true} isSpecial={true} />
}